import { ItemAction } from "@gtmhub/shared/components";
import { DropdownMenuItem, IDropdownMenuItemIcon, IDropdownMenuItemToggle, IDropdownMenuItemUiIcon } from "../gh-dropdown.models";

export class GhDropdownMenuItemBuilder {
  private menuItem: DropdownMenuItem;

  constructor() {
    this.reset();
  }

  public reset(): void {
    this.menuItem = {} as DropdownMenuItem;
  }

  public setKey(key: string): GhDropdownMenuItemBuilder {
    this.menuItem.key = key;
    return this;
  }

  public setTrack(trackName: string): GhDropdownMenuItemBuilder {
    this.menuItem.track = trackName;
    return this;
  }

  public setTrackMetaData(metaData: { [key: string]: string }): GhDropdownMenuItemBuilder {
    this.menuItem.trackMetaData = metaData;
    return this;
  }

  public setAction(action: ItemAction): GhDropdownMenuItemBuilder {
    this.menuItem.action = action;
    return this;
  }

  public setUiType(
    option: { uiType: "toggle"; value: boolean } | { uiType: "icon"; icon: string } | { uiType: "uiIcon"; iconType: string; iconTheme: "outline" | "fill" }
  ): GhDropdownMenuItemBuilder {
    switch (option.uiType) {
      case "toggle":
        (this.menuItem as IDropdownMenuItemToggle).value = option.value;
        this.menuItem.uiType = "toggle";
        break;
      case "icon":
        (this.menuItem as IDropdownMenuItemIcon).icon = option.icon;
        this.menuItem.uiType = "icon";
        break;
      case "uiIcon":
        (this.menuItem as IDropdownMenuItemUiIcon).iconType = option.iconType;
        (this.menuItem as IDropdownMenuItemUiIcon).iconTheme = option.iconTheme;
        this.menuItem.uiType = "uiIcon";
        break;
    }
    return this;
  }

  public setToBeEndOfSection(): GhDropdownMenuItemBuilder {
    this.menuItem.endOfSection = true;
    return this;
  }

  public build(): DropdownMenuItem {
    const result = this.menuItem;
    this.reset();
    return result;
  }
}
